import { useEffect, useState } from 'react';

// The current time, re-read every `intervalMs`. For a countdown that has to
// move while nothing else re-renders (the DM reply window).
//
// ⚠️ ITS OWN FILE for the useElapsedSeconds.ts reason: the inbox detail views
// are guarded by suggestOnDemandOnly.test.ts, which inspects their effects. A
// clock is a legitimate effect with nothing to do with generation, and keeping
// it out of those files keeps that guard at its strongest.
export function useNowMs(intervalMs = 30_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const handle = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(handle);
  }, [intervalMs]);
  return now;
}
